import {
  EventAccordionItemBodyComponentType,
  MinRowsForUsingVirtuoso,
} from 'src/components/Accordions';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { PurchaseOrderTable } from 'src/tables/PurchaseTable';
import { PurchaseOrderTableV2 } from 'src/tables/PurchaseTable/PurchaseTableV2';
import {
  Feature,
  PurchaseOrderTicketGroup,
  PurchaseViewMode,
} from 'src/WebApiController';

type EventTicketGroupBodyProps =
  EventAccordionItemBodyComponentType<PurchaseOrderTicketGroup>;

export const EventTicketGroupBody = (props: EventTicketGroupBodyProps) => {
  const Body = PurchaseOrderTableEventAccordionWrapper;

  return <Body {...props} />;
};

const PurchaseOrderTableEventAccordionWrapper = (
  props: EventTicketGroupBodyProps
) => {
  const {
    entities: ticketGroups,
    entitiesSummary: ticketGroupsSummary,
    entityCount: ticketGrpsCnt,
    getDataFail,
    ...rest
  } = props;

  const hasVirtuosoMinRows = ticketGrpsCnt > MinRowsForUsingVirtuoso;

  const hasPurchaseTableV2Feature = useUserHasFeature(Feature.PurchaseTableV2);

  return hasPurchaseTableV2Feature && !props.isSideTable ? (
    <PurchaseOrderTableV2
      {...rest}
      useVirtuoso={props.useVirtuoso || hasVirtuosoMinRows}
      entityCount={ticketGrpsCnt}
      entitiesSummary={ticketGroupsSummary}
      entities={ticketGroups}
      groupId={props.event.virtId}
      viewMode={PurchaseViewMode.EventTileView}
      enableColumnFilters
    />
  ) : (
    <PurchaseOrderTable
      {...rest}
      useVirtuoso={props.useVirtuoso || hasVirtuosoMinRows}
      entityCount={ticketGrpsCnt}
      entitiesSummary={ticketGroupsSummary}
      entities={ticketGroups}
      groupId={props.event.virtId}
      viewMode={PurchaseViewMode.EventTileView}
      enableColumnFilters
    />
  );
};
